import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Button,
} from "@mui/material";
import { Helmet } from "react-helmet-async";
import FormatTime from "../../AdsPage/FormatTime";
import { cardOutline, fonts, headingFonts } from "../../../Styles/Styles";
import { useNavigate } from "react-router-dom";
import LoadingAnimation from "../../Animations/LoadingAnimation";

export default function AdsReports() {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  // Fetch reports data from API
  const fetchReports = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_SERVER_BASE_URL}/ads/allreports`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (response.status === 403) {
        navigate("/login");
        return;
      }

      if (!response.ok) {
        throw new Error(
          response.status === 404
            ? "No reports found."
            : "Something went wrong. Please try again later."
        );
      }

      const data = await response.json();
      setReports(data.reports);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReports();
  }, []);

  if (loading) return <LoadingAnimation />;

  return (
    <Box sx={{ padding: 3 }}>
      <Helmet>
        <title>Ads Reports - Listed.ky</title>
        <meta name="description" content="Ads Reports - Listed.ky" />
      </Helmet>

      <Typography variant="h4" gutterBottom sx={{ ...headingFonts }}>
        Ads Reports
      </Typography>

      {error ? (
        <Box sx={{ textAlign: "center", mt: 2 }}>
          <Typography color="error" variant="body1">
            {error}
          </Typography>
        </Box>
      ) : reports.length === 0 ? (
        <Typography sx={{ mt: 2 }} variant="body1">
          No reports available.
        </Typography>
      ) : (
        <TableContainer sx={{ ...cardOutline }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ ...headingFonts }}>Ad Title</TableCell>
                <TableCell sx={{ ...headingFonts }}>Reported By</TableCell>
                <TableCell sx={{ ...headingFonts }}>Reason</TableCell>
                <TableCell sx={{ ...headingFonts }}>Reported At</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {reports.map((report) => (
                <TableRow key={report._id}>
                  <TableCell
                    sx={{
                      ...headingFonts,
                      cursor: "pointer",
                      color: "var(--primary-color)",
                    }}
                    onClick={() =>
                      report.adDetails &&
                      navigate(`/ad/${report.adDetails.uniqueId}`)
                    }
                  >
                    {report.adDetails?.title || "Ad not found"}
                  </TableCell>
                  <TableCell sx={{ ...fonts }}>
                    {report.userId?.firstName || "Unknown"}
                  </TableCell>
                  <TableCell sx={{ ...fonts }}>{report.reason}</TableCell>
                  <TableCell sx={{ ...fonts }}>
                    <FormatTime createdAt={report.createdAt} />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
}
